export const SITE_URL = "https://www.jtbfloorsinc.com";
export const OG_IMAGE = "https://www.jtbfloorsinc.com/og-image.jpg";

export const business = {
  name: "JTB Floors",
  phone: "(773) 934-2004",
  phoneHref: "tel:17739342004",
  address: "Fox River Grove, IL",
};
